import axios from "axios";
import { dbPromise } from "../main";

export class Me {
    static autentica (dados) {
        return axios.post("/auth", dados);
    }

    static version () {
        return axios.get("/version");
    }

    static logout (token) {
        return axios.delete("/catecnicos2/" + token);
    }

    static sync (param) {
        return axios.post("/sync", param);
    }

    /**
     *
     * @return {Promise<any>}
     */
    static get () {
        return new Promise(resolve => {
            dbPromise
                .then((db) => {
                    return db
                        .transaction("user", "readwrite")
                        .objectStore("user")
                        .get(1);
                })
                .then((dado) => resolve(dado));
        });
    }

    /**
     *
     * @param data
     * @return {Promise<any>}
     */
    static add (data) {
        data.id = 1;
        return new Promise(resolve => {
            dbPromise
                .then((db) => {
                    return db
                        .transaction("user", "readwrite")
                        .objectStore("user")
                        .put(data);
                })
                .then((id) => resolve(id));
        });
    }

    static clear () {
        dbPromise
            .then((db) => {
                db
                    .transaction("user", "readwrite")
                    .objectStore("user")
                    .clear();
            });
    }
}
